"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.removeQuestionNode = void 0;
const removeQuestionNode = (parent, node) => {
    var _a;
    parent.subQuestions = (_a = parent.subQuestions) === null || _a === void 0 ? void 0 : _a.filter(q => q.nodeId !== node.nodeId);
    node.parentNodeId = null;
};
exports.removeQuestionNode = removeQuestionNode;
exports.default = exports.removeQuestionNode;
